// Auto-generated from API - Do not edit manually
// Last updated: 2025-11-21 20:19:21 UTC

export const teamMembers = 
[
  {
    "id": 17,
    "type": "Board Member",
    "full_name": "Richard Gleason",
    "title": null,
    "socials": "",
    "position": "Board Secratary",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1763746765/teams/1763746765121-image%20%281%29%20-%20Richard%20Gleason.png.png",
    "bio": "",
    "created_at": "2025-11-21T17:39:26.105Z",
    "updated_at": "2025-11-21T17:39:26.105Z"
  },
  {
    "id": 16,
    "type": "Team Member",
    "full_name": "Nic Daphnet Ossiala Elonda",
    "title": null,
    "socials": "",
    "position": "Administrative officer",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1763746722/teams/1763746721802-IMG_7519%20-%20A%20O.%20E..jpeg.jpg",
    "bio": "",
    "created_at": "2025-11-21T17:38:43.602Z",
    "updated_at": "2025-11-21T17:38:43.602Z"
  },
  {
    "id": 15,
    "type": "Board Member",
    "full_name": "Jacob Nkowane",
    "title": null,
    "socials": "",
    "position": "Board Trustee",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1763746621/teams/1763746621319-886%20-%20Jacob%20Nkowane.jpeg.jpg",
    "bio": "",
    "created_at": "2025-11-21T17:37:02.447Z",
    "updated_at": "2025-11-21T17:37:02.447Z"
  },
  {
    "id": 14,
    "type": "Volunteer",
    "full_name": "Dr. Enaikato Cathy Ige-Edaba",
    "title": null,
    "socials": "https://www.linkedin.com/in/enaikato-ige-edaba-5b9538216/",
    "position": "UI/Front-end Developer",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1762863078/teams/1762863078358-WhatsApp%20Image%202025-11-11%20at%2013.03.04_16e6d30f.jpg.jpg",
    "bio": "Dr. Enai is a physician and technologist passionate about leveraging innovation to improve health and wellbeing in communities. She combines clinical expertise with technology to create solutions that empower people, strengthen systems, and support sustainable access to essential resources like clean water.",
    "created_at": "2025-11-11T12:11:19.221Z",
    "updated_at": "2025-11-11T12:11:19.221Z"
  },
  {
    "id": 13,
    "type": "Volunteer",
    "full_name": "Matthew Murphy",
    "title": null,
    "socials": "",
    "position": "Fundraising Officer",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1761589667/teams/1761589667067-1742545949932.jpg.jpg",
    "bio": "",
    "created_at": "2025-10-27T18:10:15.422Z",
    "updated_at": "2025-10-27T18:10:15.422Z"
  },
  {
    "id": 1,
    "type": "Volunteer",
    "full_name": "Bupe Katongo",
    "title": null,
    "socials": "www.linkedin.com/in/6upe",
    "position": "Software Engineer",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1759574116/teams/1759574115943-WhatsApp%20Image%202025-10-04%20at%2012.30.49_89dae985.jpg.jpg",
    "bio": "I have a passion for blending creativity with technical expertise to develop innovative software solutions and captivating visual designs.",
    "created_at": "2025-10-04T10:34:27.020Z",
    "updated_at": "2025-10-04T10:34:27.020Z"
  },
  {
    "id": 12,
    "type": "Volunteer",
    "full_name": "Aniket Chopade",
    "title": null,
    "socials": "",
    "position": "Software Engineer",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1759345317/teams/1759345314196-Aniket.jpg.jpg",
    "bio": "",
    "created_at": "2025-09-27T17:24:34.678Z",
    "updated_at": "2025-09-27T17:24:34.678Z"
  },
  {
    "id": 11,
    "type": "Team Member",
    "full_name": "Ange Arsene Ossiala",
    "title": null,
    "socials": "",
    "position": "Country Representative- Congo Brazzaville",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1758993821/teams/1758993818926-Ange%20Arsene%20Ossiala.jpg.jpg",
    "bio": "",
    "created_at": "2025-09-27T17:23:42.091Z",
    "updated_at": "2025-09-27T17:23:42.091Z"
  },
  {
    "id": 10,
    "type": "Team Member",
    "full_name": "Siyana Zulu",
    "title": null,
    "socials": "",
    "position": "Finance Manager",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1758993806/teams/1758993803295-Siyana%20zulu.jpg.jpg",
    "bio": "",
    "created_at": "2025-09-27T17:23:26.519Z",
    "updated_at": "2025-09-27T17:23:26.519Z"
  },
  {
    "id": 9,
    "type": "Team Member",
    "full_name": "Talent Madubeka",
    "title": null,
    "socials": "",
    "position": "Sustainable Livelihoods Officer",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1758993792/teams/1758993790266-Talent%20Madubeka.jpg.jpg",
    "bio": "",
    "created_at": "2025-09-27T17:23:13.135Z",
    "updated_at": "2025-09-27T17:23:13.135Z"
  },
  {
    "id": 8,
    "type": "Team Member",
    "full_name": "Temwa Gondwe",
    "title": null,
    "socials": "",
    "position": "Advocacy & Communication Officer",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1758993783/teams/1758993781321-Temwa%20Gondwe.jpg.jpg",
    "bio": "",
    "created_at": "2025-09-27T17:23:04.047Z",
    "updated_at": "2025-09-27T17:23:04.047Z"
  },
  {
    "id": 7,
    "type": "Team Member",
    "full_name": "Isaiah Mwanza",
    "title": null,
    "socials": "",
    "position": "Director of Projects",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1758993769/teams/1758993767046-Isaiah%20Mwanza.jpg.png",
    "bio": "",
    "created_at": "2025-09-27T17:22:50.310Z",
    "updated_at": "2025-09-27T17:22:50.310Z"
  },
  {
    "id": 6,
    "type": "Team Member",
    "full_name": "Rodney Katongo",
    "title": null,
    "socials": "",
    "position": "Co-Founder & Chief Executive Officer",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1758993756/teams/1758993753606-Rodney%20Katongo.jpg.png",
    "bio": "",
    "created_at": "2025-09-27T17:22:36.791Z",
    "updated_at": "2025-09-27T17:22:36.791Z"
  },
  {
    "id": 5,
    "type": "Board Member",
    "full_name": "Anna Butler",
    "title": null,
    "socials": "",
    "position": "Global Networks & Partnerships Advisor",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1758993739/teams/1758993737104-Anna%20Butler.png.png",
    "bio": "Anna is a Harvard Scholar with extensive experience in sustainable social programming, equitable education access, and global protection policies",
    "created_at": "2025-09-27T17:22:20.580Z",
    "updated_at": "2025-09-27T17:22:20.580Z"
  },
  {
    "id": 4,
    "type": "Board Member",
    "full_name": "Maurice Dillon",
    "title": null,
    "socials": "",
    "position": "Finance & Resource Mobilisation",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1758993724/teams/1758993721849-Maurica%20dillon.png.png",
    "bio": "Maurice is a Master of Laws and is a member of the Royal Institute of British Architects. He has delivered numerous major projects throughout Middle East, Africa and Europe. He brings with him a wealth of experience in economic development as well as best-practice in sustainable development",
    "created_at": "2025-09-27T17:22:04.880Z",
    "updated_at": "2025-09-27T17:22:04.880Z"
  },
  {
    "id": 3,
    "type": "Board Member",
    "full_name": "Paul Kapanda",
    "title": null,
    "socials": "",
    "position": "Co-founder & Co-Chairman",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1758993697/teams/1758993695051-Paul%20Kapanda.png.png",
    "bio": "Paul is the Co-founder & Co-Chairman of Africa Access Water, he has more than 20 years of experience in water systems and business management.",
    "created_at": "2025-09-27T17:21:38.059Z",
    "updated_at": "2025-09-27T17:21:38.059Z"
  },
  {
    "id": 2,
    "type": "Board Member",
    "full_name": "Reuben Banda",
    "title": null,
    "socials": "",
    "position": "Chairman",
    "image_url": "https://res.cloudinary.com/dz3tgvaiw/image/upload/v1758993624/teams/1758993621820-Reuben%20Band.png.png",
    "bio": "Reuben is the Managing Director and Co-Founder of Musika Development Limited, one of the biggest organisations in Zambia. He has more than 20 years of experience in Agribusiness and market systems",
    "created_at": "2025-09-27T17:20:25.063Z",
    "updated_at": "2025-09-27T17:20:25.063Z"
  }
]
;
